import { Navigate, Outlet } from 'react-router'
import { useAdminAuth } from '@/contexts/AdminAuthContext'
import { ShieldAlert, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function AdminProtectedRoute() {
  const { isAuthenticated, isAuthorized, isLoading, signOut } = useAdminAuth()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (!isAuthorized) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="mx-auto max-w-md text-center">
          <ShieldAlert className="mx-auto mb-4 h-16 w-16 text-destructive" />
          <h1 className="mb-2 text-2xl font-bold">Access Denied</h1>
          <p className="mb-6 text-muted-foreground">
            Your account does not have admin privileges. Contact a super admin to request access.
          </p>
          <Button variant="outline" onClick={() => signOut()}>
            Sign Out
          </Button>
        </div>
      </div>
    )
  }

  return <Outlet />
}
